
<style lang="less" scoped>
    .template-contain {
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      .template-item {
        margin: 10px !important;
        width: 30%;
        position: relative;
        margin: 10px 0;
        border: grey dashed 1px;
        padding: 5px;
        border-radius: 10px;
        .upload_file {
            display: flex;
        }
        .close-icon {
          position: absolute;
          left: -9px;
          top: -12px;
          z-index: 1000;
        }
    }
      .special {
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
</style>
<style lang="less">
    .upload_class {
      .ivu-modal-body {
       //  max-height: 800px !important;
      }
    }
</style>
<template>
  <div class="legel_audit">
    <Modal
      v-model="showModal"
      class="upload_class"
      :closable="false"
      :mask-closable="false"
      title="编辑合同模板配置"
      fullscreen
    >
      <Spin
        v-if="getLoading"
        size="large"
        fix
      />
      <Form
        ref="formValidate"
        :model="formData"
        :label-width="100"
      >
        <FormItem
          label="配置名称"
          prop="name"
          :rules="{required: true, message: '配置名称必填', trigger: 'blur' }"
        >
          <Input
            v-model="formData.name"
            placeholder="请输入配置名称"
          />
        </FormItem>
        <div class="template-contain">
          <div
            v-for="(item,index) in formData.content"
            :key="index"
            class="template-item"
          >
            <Icon
              v-if="formData.content.length>1"
              type="ios-close-circle"
              class="close-icon"
              size="24"
              @click="deletItem(index)"
            />
            <FormItem
              :label="'描述'+(index+1)"
              :prop="'content.' + index + '.desc'"
              :rules="{required: true, message: '描述必填', trigger: 'blur'}"
            >
              <Input
                v-model="item.desc"
                type="textarea"
                placeholder="请输入描述"
              />
            </FormItem>
            <FormItem
              :label="'合同模板'+(index+1)"
              :prop="'content.' + index + '.name'"
              :rules="{required: true, message: '模板必须上传', trigger: 'blur'}"
            >
              <FileUploader
                v-show="item.showEdit"
                :format="['docx']"
                @start="item.loading = true"
                @uploaded="importFinish(arguments,index)"
                @finally="item.loading = false"
              />
              <div
                v-show="item.showEdit&&!item.loading&&!!item.name"
              >
                <span style="float:right">
                  <Button
                    type="text"
                    @click="ediFile(index)"
                  >取消编辑</Button>
                </span>
              </div>
              <div
                v-show="!item.showEdit&&!item.loading"
                class="upload_file"
              >
                <p style="flex:1">
                  {{ item.name }}
                </p>
                <span>
                  <Button
                    type="text"
                    @click="ediFile(index)"
                  >编辑</Button>
                </span>
              </div>
            </FormItem>
          </div>
          <div
            class="template-item special"
            @click="addNewOne"
          >
            <Icon
              type="ios-add-circle-outline"
              size="50"
            />
          </div>
        </div>
      </Form>
      <template v-slot:footer>
        <i-button
          type="text"
          @click.native="closeModal"
        >
          取消
        </i-button>
        <i-button
          :loading="subMitDataLoading"
          type="primary"
          @click.native="submit('formValidate')"
        >
          保存
        </i-button>
      </template>
    </Modal>
  </div>
</template>
<script>
  import {KEY_NAME, DEFAULT_DATA, DEFAULT_DATA_ALL } from './constants'
  import { getConfigApi,submitConfigApi } from './editorServicer'
  import FileUploader from './../../components/file/uploader'
      //  '../components/file/uploader';
    export default {
      components:{ FileUploader } ,
        props: {
          value: {
            type: Boolean,
            default:() => false
          },
        },
        data (){
            return {
                showModal: this.value,
                getLoading: false,
                subMitDataLoading: false,
                formData:{
                  name:'',
                  key_name:'',
                  content:[
                    {
                        desc:'',
                        name:'',
                        showEdit: true,
                        loading: false,
                    }
                  ]
                }
            }
        },
        watch: {
             value (val) {
               this.showModal = val;
               if(val) {
                 this.subMitDataLoading = false
                 this.getLoading = true
                 const obj = Util.clone(DEFAULT_DATA_ALL)
                 getConfigApi.call(this,{ key_name: KEY_NAME },() => {
                  this.closeModal()
                  this.getLoading = false
                 }).then(data => {
                   Object.keys(obj).forEach(key => {
                     if(key!=='content') {
                        this.$set(this.formData,key,data[key]||obj[key])
                     }
                   })
                   const dataContent = data.content||[]
                   if(dataContent.length>=1) {
                     dataContent.forEach((item,index) => {
                        item.showEdit = false
                        item.loading = false
                        item.name = item.file.name
                        this.$set(this.formData.content,index,item)
                    })
                   }

                   this.getLoading = false
                 })
               } else {
                this.formData = Util.clone(DEFAULT_DATA_ALL)
               }
             }
        },
        methods: {
          importFinish (data,index) {
            const arg = data[0]
            this.formData.content[index].showEdit = false
            this.formData.content[index].name = arg.name
            this.$set(this.formData.content[index],name,arg.name)
            this.formData.content[index].file = arg
          },
          ediFile (index) {
           this.formData.content[index].showEdit = !this.formData.content[index].showEdit
          },
          addNewOne () {
            this.formData.content.push(Util.clone(DEFAULT_DATA))
          },
          deletItem (index) {
            if(!this.formData.content[index].desc&&!this.formData.content[index].name) {
              this.formData.content.splice(index,1)
              return
            }
               this.$Modal.confirm({
                    title: '提示',
                    content: '是否要删除当前模版',
                    onOk: () => {
                       this.formData.content.splice(index,1)
                    }
                });
          },
          submit (name) {
              this.$refs[name].validate((success) => {
                    if (success) {
                      this.subMitDataLoading = true
                      const submitData = {
                        name:this.formData.name,
                        key_name:this.formData.key_name,
                        id: this.formData.id,
                        content: []
                      }
                      for (const value of this.formData.content) {
                        const { desc,file } = value
                        submitData.content.push({
                          desc,
                          file
                        })

                      }
                      submitConfigApi.call(this,submitData).then((res) => {
                        if(res.code===1) {
                           this.closeModal()
                        }
                        this.subMitDataLoading = false
                      }).catch(() => {
                        this.subMitDataLoading = false
                      })
                    }
                })
          },
          closeModal () {
            this.$emit('closeModal',false)
          },
          changePersonStatus (index) {
              this.formData.content[index].active = !this.formData.content[index].active
          }
        },
    }
</script>
